/* italiamarket theme — global JS */
(function(){
  "use strict";
  var i18n=window.imI18n||{};
  function toast(m){
    var t=document.getElementById('im-toast');
    if(!t){ return; }
    t.textContent=m; t.hidden=false; t.classList.add('show');
    clearTimeout(toast._); toast._=setTimeout(function(){ t.classList.remove('show'); setTimeout(function(){ t.hidden=true; },300); },1900);
  }
  window.imToast = toast;

  /* ---- money formatting (Shopify money_format) ---- */
  function fmtNum(n, dec, ts, ds){
    dec = dec==null?2:dec; ts = ts==null?',':ts; ds = ds==null?'.':ds;
    var s = (Math.abs(n)/100).toFixed(dec);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
    return parts.join(dec?ds:'');
  }
  function money(cents){
    var fmt = window.imMoneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, key){
      switch(key){
        case 'amount': return fmtNum(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }
  window.imMoney = money;

  /* ---- card CTA: "Add" button morphs into a qty stepper after adding ---- */
  function setCta(cta, qty){
    if(!cta) return;
    var add = cta.querySelector('.st-add--cart');
    var qbox = cta.querySelector('.st-qty');
    if(!qbox){ return; }            /* no stepper in this design — Add button stays put */
    var nEl = qbox.querySelector('.st-qty-n');
    if(qty > 0){
      if(nEl) nEl.textContent = qty;
      if(add) add.hidden = true;
      qbox.hidden = false;
    } else {
      if(add) add.hidden = false;
      qbox.hidden = true;
      if(nEl) nEl.textContent = '1';
    }
  }

  /* stepper +/- adjusts the cart line directly (change.js); 0 reverts to Add */
  document.addEventListener('click', function(e){
    var s = e.target.closest('.st-qty-b[data-step]');
    if(!s) return;
    e.preventDefault(); e.stopPropagation();
    var cta = s.closest('.st-cardcta'); if(!cta) return;
    var id = cta.getAttribute('data-variant');
    var nEl = cta.querySelector('.st-qty-n');
    var next = Math.max(0, (parseInt(nEl.textContent,10)||1) + parseInt(s.getAttribute('data-step'),10));
    var btns = cta.querySelectorAll('.st-qty-b'); btns.forEach(function(x){x.disabled=true;});
    fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: id, quantity: next })
    }).then(function(r){ return r.json(); })
      .then(function(){ setCta(cta, next); document.dispatchEvent(new CustomEvent('cart:refresh')); return updateCart(); })
      .catch(function(){ toast(i18n.couldNotUpdate||'Could not update cart'); })
      .then(function(){ btns.forEach(function(x){x.disabled=false;}); });
  });

  /* Add button: add 1, morph to stepper, pop the mini-cart */
  document.addEventListener('click', function(e){
    var b = e.target.closest('.st-add--cart[data-add]');
    if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var id = b.getAttribute('data-add'); if(!id) return;
    var cta = b.closest('.st-cardcta');
    b.disabled = true;
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(line){
        setCta(cta, line.quantity || 1);
        if(!cta || !cta.querySelector('.st-qty')){
          var lbl=b.querySelector('span');
          if(lbl){ var o=lbl.textContent; lbl.textContent=i18n.added||'Added'; b.classList.add('is-added');
            setTimeout(function(){ lbl.textContent=o; b.classList.remove('is-added'); },1200); }
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return updateCart(line);
      })
      .catch(function(){ toast(i18n.couldNotAdd||'Could not add to cart'); })
      .then(function(){ b.disabled=false; });
  });

  /* on load: reflect existing cart quantities in the cards */
  function syncCards(){
    var ctas = document.querySelectorAll('.st-cardcta[data-variant]');
    if(!ctas.length) return;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var byId = {};
      cart.items.forEach(function(it){ byId[String(it.variant_id)] = (byId[String(it.variant_id)]||0) + it.quantity; });
      ctas.forEach(function(cta){
        var q = byId[String(cta.getAttribute('data-variant'))] || 0;
        if(q > 0) setCta(cta, q);
      });
    }).catch(function(){});
  }
  syncCards();

  /* ---- mini-cart popup + header totals ---- */
  var mcTimer;
  var ICON_CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_BAG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2l2.4 12.2a1 1 0 0 0 1 .8h8.2a1 1 0 0 0 1-.8L20 8H6"/><circle cx="9" cy="20" r="1.3"/><circle cx="18" cy="20" r="1.3"/></svg>';

  function rowHtml(line){
    var img = line.image || (line.featured_image && line.featured_image.url) || '';
    var src = img ? (img.indexOf('?')>-1 ? img+'&width=120' : img+'?width=120') : '';
    var url = line.url || (line.handle ? '/products/'+line.handle : '#');
    return '<a class="st-minicart-item" href="'+url+'">'+
      '<div class="st-minicart-thumb">'+(src?'<img src="'+src+'" alt="" width="52" height="52">':'')+'</div>'+
      '<div class="st-minicart-info"><div class="st-minicart-name">'+(line.product_title||line.title||'')+'</div>'+
      '<div class="st-minicart-meta">'+(i18n.quantity||'Qty')+' '+(line.quantity||1)+' &middot; '+money(line.final_line_price||line.line_price||line.price||0)+'</div></div></a>';
  }
  function setHead(icon, text){
    var h = document.getElementById('st-minicart-head'); if(h) h.innerHTML = icon+'<span>'+text+'</span>';
  }
  function setActionsVisible(on){
    var sub=document.getElementById('st-minicart-sub'), co=document.getElementById('st-minicart-checkout');
    if(sub) sub.hidden=!on; if(co) co.hidden=!on;
  }
  function showMiniCart(autohide){
    var mc = document.getElementById('st-minicart'); if(!mc) return;
    mc.hidden = false;
    requestAnimationFrame(function(){ mc.classList.add('show'); });
    clearTimeout(mcTimer);
    if(autohide) mcTimer = setTimeout(hideMiniCart, 5000);
  }
  function hideMiniCart(){
    var mc = document.getElementById('st-minicart'); if(!mc) return;
    mc.classList.remove('show');
    setTimeout(function(){ mc.hidden = true; }, 260);
  }

  /* popup after adding: confirmation + the just-added line, auto-hides */
  function popAdded(line){
    var mc=document.getElementById('st-minicart'); if(mc) mc.dataset.mode='added';
    var body=document.getElementById('st-minicart-body');
    setHead(ICON_CHECK, i18n.addedToCart||'Added to cart');
    if(body) body.innerHTML = line ? rowHtml(line) : '';
    setActionsVisible(true);
    showMiniCart(true);
  }
  /* popup on cart-icon click: full cart contents, stays open */
  function openCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      paintHeader(cart);
      var mc=document.getElementById('st-minicart'); if(mc) mc.dataset.mode='full';
      var body=document.getElementById('st-minicart-body');
      setHead(ICON_BAG, i18n.cartTitle||'Your cart');
      if(cart.item_count>0){
        if(body) body.innerHTML = cart.items.map(rowHtml).join('');
        setActionsVisible(true);
      } else {
        if(body) body.innerHTML = '<div class="st-minicart-empty">'+(i18n.cartEmpty||'Your cart is empty')+'</div>';
        setActionsVisible(false);
      }
      showMiniCart(false);
    }).catch(function(){});
  }

  /* cart icon: show the full-cart popup instead of navigating (close only if already showing full cart) */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.st-cart-btn');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var mc = document.getElementById('st-minicart');
    if(mc && !mc.hidden && mc.dataset.mode==='full') hideMiniCart(); else openCart();
  });
  /* close on outside click / Esc */
  document.addEventListener('click', function(e){
    var mc = document.getElementById('st-minicart');
    if(mc && !mc.hidden && !e.target.closest('.st-cart-wrap')) hideMiniCart();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') hideMiniCart(); });

  /* ---- search popup (mobile header) + live predictive search ---- */
  var SP_CATS = {
    "gourmet":{t:"Salumi, Formaggi & Gourmet",p:'<path d="M4 15.2 18.6 7a1.5 1.5 0 0 0-1-2.8L8 6.4A3 3 0 0 0 5.7 8.4L4.2 13a1.4 1.4 0 0 0-.2 2.2z"/><path d="M4.2 15.2H19"/><circle cx="9" cy="11.6" r=".9"/><circle cx="13.4" cy="9.6" r=".9"/>'},
    "pasta-riz":{t:"Pasta & Riso",p:'<path d="M3.5 11.5h17a8.5 8.5 0 0 1-17 0z"/><path d="M7.5 11.5c.6-4 2.4-6 4.5-6.5M12 11.5c0-3 1-5 3-6"/>'},
    "sosove-konservi":{t:"Salse & Conserve",p:'<rect x="6" y="8.5" width="12" height="11.5" rx="2.2"/><path d="M8 8.5v-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M7.6 12.5h8.8"/>'},
    "zehtin-kiler":{t:"Olio & Dispensa",p:'<path d="M10 3.5h4v2.6l1.4 1.9a3 3 0 0 1 .6 1.8V18a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V9.7a3 3 0 0 1 .6-1.8L10 6.1z"/><path d="M8.4 13h7.2"/>'},
    "kafe-napitki":{t:"Caffè & Bevande",p:'<path d="M5 8.5h11v4.5a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4z"/><path d="M16 9.3h2.4a2 2 0 0 1 0 4H16"/><path d="M8 3.5v2M11 3.5v2"/>'},
    "vino-bira":{t:"Vino & Birra",p:'<path d="M8 3.6h8l-.6 5a3.4 3.4 0 0 1-6.8 0z"/><path d="M12 13.6v4.8M9.2 19.4h5.6"/>'},
    "sladki-snaki":{t:"Dolci & Snack",p:'<path d="M6.4 11.5h11.2l-1.4 8H7.8z"/><path d="M7 11.5a5 5 0 0 1 10 0"/><path d="M12 4v2.2"/>'},
    "domashna-grizha":{t:"Casa & Pulizia",p:'<path d="M10 8.5h5V18a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z"/><path d="M10 8.5v-2h3v-2"/><path d="M6.5 6.5h3M5.5 8.5h1.2M5.5 10.5h1.2"/>'},
    "lichna-grizha":{t:"Cura della persona",p:'<rect x="8" y="9" width="8" height="11" rx="2.2"/><path d="M10 9V7h4M13 4h-2.2v3"/><path d="M8.4 13h7.2"/>'},
    "zhivotni":{t:"Animali",p:'<circle cx="8.2" cy="9" r="1.4"/><circle cx="12" cy="7.4" r="1.4"/><circle cx="15.8" cy="9" r="1.4"/><path d="M12 12c-3 0-5 2-5 3.9a2.5 2.5 0 0 0 5 .3 2.5 2.5 0 0 0 5-.3C17 14 15 12 12 12z"/>'},
    "bebeshki":{t:"Bimbi",p:'<rect x="9" y="8.5" width="6" height="11.5" rx="2"/><path d="M9.8 8.5v-2h4.4v2"/><path d="M11 4.2h2v2.3h-2z"/><path d="M9.6 12.5h4.8"/>'},
    "cucina":{t:"Cucina & Casa",p:'<path d="M5 10.5h14v3.5a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4z"/><path d="M3.5 10.5h17"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/>'}
  };
  function spEl(){ return document.getElementById('st-searchpop'); }
  var spDefault=null, spTimer=null, spSeq=0;
  function showSearch(){
    var p=spEl(); if(!p)return;
    var panel=document.getElementById('st-searchpop-panel');
    if(spDefault===null && panel) spDefault=panel.innerHTML;
    p.hidden=false; void p.offsetHeight; p.classList.add('show');
    var i=document.getElementById('st-searchpop-input'); if(i) setTimeout(function(){ try{ i.focus(); }catch(e){} }, 80);
  }
  function hideSearch(){ var p=spEl(); if(!p||p.hidden)return; p.classList.remove('show'); setTimeout(function(){ p.hidden=true; }, 240); }
  function spMoney(v){ var n=parseFloat(v); if(isNaN(n)) return ''; return '€'+n.toFixed(2).replace('.',','); }
  function spEsc(s){ return (s||'').replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function spIcon(m){ var c=SP_CATS[m]; return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'+((c&&c.p)||'')+'</svg>'; }
  function spRender(q, prods, panel){
    panel=panel||document.getElementById('st-searchpop-panel'); if(!panel)return;
    var searchUrl=(window.imSearchUrl||'/search')+'?q='+encodeURIComponent(q);
    if(!prods.length){ panel.innerHTML='<div class="sr-msg">Nessun prodotto per &ldquo;'+spEsc(q)+'&rdquo;.</div><a class="sr-all" href="'+searchUrl+'">Cerca comunque &rarr;</a>'; return; }
    var order=[], buckets={};
    prods.forEach(function(p){
      var m=((p.tags||[]).filter(function(t){return t.indexOf('macro:')===0;})[0]||'macro:altro').slice(6);
      if(!buckets[m]){ buckets[m]=[]; order.push(m); }
      buckets[m].push(p);
    });
    order.sort(function(a,b){ return buckets[b].length-buckets[a].length; });
    var html='';
    order.slice(0,3).forEach(function(m){
      var items=buckets[m], cat=SP_CATS[m]||{t:'Altri prodotti',p:''};
      var colUrl=(window.imMacroCols&&window.imMacroCols[m])||searchUrl;
      html+='<div class="sr-cat"><div class="sr-cat-h"><span class="sr-cat-ic">'+spIcon(m)+'</span><span class="sr-cat-t">'+spEsc(cat.t)+'</span><span class="sr-cat-n">'+items.length+'</span></div>';
      items.slice(0,2).forEach(function(p){
        var img=(p.featured_image&&p.featured_image.url)||p.image||'';
        var src=img?(img.indexOf('?')>-1?img+'&width=120':img+'?width=120'):'';
        html+='<a class="sr-item" href="'+p.url+'"><span class="sr-thumb">'+(src?'<img src="'+src+'" alt="" width="46" height="46" loading="lazy">':'')+'</span><span class="sr-info"><span class="sr-nm">'+spEsc(p.title)+'</span><span class="sr-pr">'+spMoney(p.price)+'</span></span></a>';
      });
      if(items.length>2) html+='<a class="sr-more" href="'+colUrl+'">Vedi tutti in '+spEsc(cat.t)+' &rarr;</a>';
      html+='</div>';
    });
    html+='<a class="sr-all" href="'+searchUrl+'">Vedi tutti i risultati per &ldquo;'+spEsc(q)+'&rdquo; &rarr;</a>';
    panel.innerHTML=html;
  }
  function spQuery(q, panel){
    var seq=++spSeq;
    fetch('/search/suggest.json?q='+encodeURIComponent(q), {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(j){
        if(seq!==spSeq) return;
        var prods=(j.resources&&j.resources.results&&j.resources.results.products)||[];
        spRender(q, prods, panel);
      }).catch(function(){ if(seq===spSeq) spRender(q, [], panel); });
  }
  /* predictive search: powers BOTH the header popup (#st-searchpop-input) and the
     categories sheet inline search (#im-sh-input) — same grouped results, no context switch */
  document.addEventListener('input', function(e){
    if(!e.target) return;
    var inSheet = e.target.id==='im-sh-input';
    if(e.target.id!=='st-searchpop-input' && !inSheet) return;
    var q=e.target.value.trim();
    var panel = inSheet ? document.getElementById('im-sh-results') : document.getElementById('st-searchpop-panel');
    var cats  = inSheet ? document.getElementById('im-sh-cats') : null;
    clearTimeout(spTimer);
    if(q.length<2){
      if(inSheet){ if(panel){panel.hidden=true;panel.innerHTML='';} if(cats)cats.hidden=false; }
      else if(panel && spDefault!==null){ panel.innerHTML=spDefault; }
      return;
    }
    if(inSheet && cats) cats.hidden=true;
    if(panel){ panel.hidden=false; panel.innerHTML='<div class="sr-msg">Cerco &ldquo;'+spEsc(q)+'&rdquo;…</div>'; }
    spTimer=setTimeout(function(){ spQuery(q, panel); }, 180);
  });
  document.addEventListener('click', function(e){
    var btn=e.target.closest('.js-search-open');
    if(btn){ e.preventDefault(); e.stopPropagation(); var p=spEl(); if(p && !p.hidden){ hideSearch(); } else { showSearch(); } return; }
    var p2=spEl(); if(p2 && !p2.hidden && !e.target.closest('#st-searchpop') && !e.target.closest('.js-search-open')) hideSearch();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') hideSearch(); });

  /* Mobile app viewport: follow the visible area while the software keyboard is open. */
  (function(){
    var vv=window.visualViewport, root=document.documentElement;
    function syncViewport(){
      var h=vv?vv.height:window.innerHeight, top=vv?vv.offsetTop:0;
      root.style.setProperty('--im-vvh',Math.round(h)+'px');
      root.style.setProperty('--im-vv-top',Math.round(top)+'px');
      root.classList.toggle('im-keyboard-open',h < window.innerHeight-120);
    }
    syncViewport();
    window.addEventListener('resize',syncViewport,{passive:true});
    if(vv){vv.addEventListener('resize',syncViewport,{passive:true});vv.addEventListener('scroll',syncViewport,{passive:true});}
    document.addEventListener('focusin',function(e){
      if(!e.target.matches('#st-searchpop-input,#im-sh-input'))return;
      syncViewport();setTimeout(function(){e.target.scrollIntoView({block:'nearest'});},80);
    });
  })();

  function paintHeader(cart){
    var badges=document.querySelectorAll('.st-cart-badge');
    var total=document.querySelector('.st-cart-total');
    var mcTotal=document.getElementById('st-minicart-total');
    badges.forEach(function(badge){ if(cart.item_count>0){ badge.hidden=false; badge.textContent=cart.item_count; } else { badge.hidden=true; } });
    if(total){ total.innerHTML=money(cart.total_price); total.classList.toggle('is-empty', cart.item_count===0); }
    if(mcTotal){ mcTotal.innerHTML=money(cart.total_price); }
  }
  function updateCart(addedLine){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      paintHeader(cart);
      var mc=document.getElementById('st-minicart');
      if(addedLine){ popAdded(addedLine); }
      else if(mc && !mc.hidden){ openCart(); } /* keep an open popup in sync after +/- */
    }).catch(function(){});
  }
  window.imUpdateCart = updateCart;

  /* sticky header elevation on scroll (installed-app feel) */
  (function(){
    var bar=document.querySelector('.st-bar'); if(!bar) return;
    function s(){ bar.classList.toggle('is-scrolled', (window.scrollY||window.pageYOffset)>6); }
    s(); window.addEventListener('scroll', s, {passive:true});
  })();

  /* ---- pack-size badge: surface size (750 мл, 500 г, 3 л) from the product name so it's never lost to truncation ---- */
  function sizeBadges(){
    var RE=/((?:\d+\s*[xх×]\s*)?\d+(?:[.,]\d+)?)\s*(мл|кг|гр|г|л|ml|kg|cl|g|l)(?![а-яёА-ЯЁa-zA-Z])/gi;
    var NORM={'гр':'г'};
    document.querySelectorAll('.st-card').forEach(function(card){
      if(card.querySelector('.st-size')) return;
      var nameEl=card.querySelector('.st-card-name'), img=card.querySelector('.st-card-img');
      if(!nameEl||!img) return;
      var txt=nameEl.textContent||'', m, last=null; RE.lastIndex=0;
      while((m=RE.exec(txt))){ last=m; }
      if(!last) return;
      var num=last[1].replace(/\s+/g,'').replace(/[хx×]/gi,'×');
      var unit=last[2].toLowerCase(); unit=NORM[unit]||unit;
      var b=document.createElement('span'); b.className='st-size';
      b.innerHTML='<span class="v"></span><span class="u"></span>';
      b.querySelector('.v').textContent=num; b.querySelector('.u').textContent=unit;
      img.appendChild(b);
    });
  }
  try{ sizeBadges(); }catch(e){}

  /* Scroll reveal */
  var els = document.querySelectorAll('[data-reveal]');
  if('IntersectionObserver' in window && els.length){
    var io = new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { threshold:.06, rootMargin:'0px 0px -4% 0px' });
    els.forEach(function(el){ if(el.getBoundingClientRect().top < innerHeight*.96){ el.classList.add('is-in'); } else { io.observe(el); } });
    setTimeout(function(){ document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function(el){ el.classList.add('is-in'); }); }, 1200);
  } else {
    els.forEach(function(el){ el.classList.add('is-in'); });
  }
})();
